import Redirection from './Redirection';
import { useState } from 'react';
import Redirecting from './Redirecting';
import { useRedirection } from './useRedirection';
import DecoupledRedirection from './DecoupledRedirection';

const RedirectionStep = () => {
	const { bankName, bankRedirectMethod, redirectUser, bankLogo } = useRedirection();
	const [hasStarted, setHasStarted] = useState<boolean>(false);

	if (hasStarted) {
		const props = { bankName, bankLogo };
		const isSameWindow = bankRedirectMethod === 'sameWindow';
		return isSameWindow ? <Redirecting {...props} /> : <DecoupledRedirection {...props} />;
	}

	const onRedirection = () => {
		setHasStarted(true);
		redirectUser();
	};

	return <Redirection onRedirection={onRedirection} bankName={bankName} bankLogo={bankLogo} />;
};

export default RedirectionStep;
